import ApiRoutes from "api/apiRoutes";
import { exeRequest } from "../http/requestConfig";

export default class PositionService {
    
    getAll(sCallBack, eCallBack) {
        exeRequest(ApiRoutes.positionResource, {}, sCallBack, eCallBack)
    }
}